import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: ${CUST.eyebrowText};
`;

// The multicolour Lumio mark (same gradient asset as the Lumio panel header + top
// bar). A gradient image, so a plain <img>, not a tintable glyph.
export const LumioMark = styled.img`
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  display: block;
`;

export const Label = styled(Text)`
  font-size: 18px;
  line-height: 1.2;
  color: ${CUST.eyebrowText};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RefreshBtn = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: none;
  background: transparent;
  color: ${CUST.accentText};
  cursor: pointer;
  transition: filter ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover {
    filter: brightness(1.1);
  }
`;

export const RefreshLabel = styled(Text)`
  font-size: 13.5px;
  line-height: 18px;
  color: ${CUST.accentText};
  white-space: nowrap;
`;